import { SHARED_ROUTES } from '@aibees/shared/constants';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { usePaymentStatus } from '@aibees/shared/hooks/payment/use-payment-status';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { PLAN_EXPIRY_HIDDEN } from '../subscription-bar/constants';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentBarProps as Props } from './types';

export const PaymentBar = memo(({ className }: Props) => {
  const { paymentFailed } = usePaymentStatus();
  const { isLoading } = useCurrentSubscriptionApi();

  if (PLAN_EXPIRY_HIDDEN || !paymentFailed || isLoading) return null;

  const text = 'Payment Failed';
  const buttonText = 'Manage Billing';
  const to = SHARED_ROUTES.billing;

  return (
    <Styled.Wrapper
      className={classnames('PaymentBar', className)}
      sx={SX.root}
      icon={false}
    >
      <Typography variant="body2" fontWeight={600} sx={SX.text}>
        {text}
      </Typography>
      <Styled.CheckBilling size="small" to={to}>
        <Typography variant="body3" fontWeight={600}>
          {buttonText}
        </Typography>
      </Styled.CheckBilling>
    </Styled.Wrapper>
  );
});

PaymentBar.displayName = 'PaymentBar';
